import { apiRequest } from "./api-client";

export interface AiDisclosureConfig {
  enabled: boolean;
  updatedAt: string | null;
}

/** 公开合规配置。请求失败时调用方必须默认展示标识。 */
export function fetchAiDisclosureConfig(
  signal?: AbortSignal,
): Promise<AiDisclosureConfig> {
  return apiRequest<AiDisclosureConfig>("/api/v1/app/compliance", {
    ...(signal ? { signal } : {}),
  });
}
